import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAutomationViewLogRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-view-log',
	path: '/jira/servicedesk/projects/:projectKey/settings/automation/log/:ruleId',
};
